import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './VideoReview.css';
import videoreviewimage from '../../assets/pageimages/VideoReview.webp';

function VideoReviewHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>VideoReview</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/videoreview-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="videoreview-bottomlink-style" />My Videos</Link></div>
              <div className="bottom-buttons-box"><Link to="/videoreview-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="videoreview-bottomlink-style" />My Reviews</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="videoreview-id" src={videoreviewimage} alt="VideoReview Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default VideoReviewHome;
